import React, { useContext } from 'react';

import { CampaignDetails, CampaignSectionRow } from './RecipientCollectionsLayout';
import KeyValueReadOnlyFields from 'src/presentation/components/pages/proactiveCommunications/components/KeyValueReadOnlyFields';
import { RecipientCollectionContext } from './RecipientCollections';
import { Section } from 'src/presentation/components/forms/Layout';
import { ControlLabel } from 'src/presentation/components/agent_desktop_components';

const CampaignDetailsSection = ({ campaign }) => {
  const { campaignContentDetailsComponent } = useContext(RecipientCollectionContext);

  const CampaignContentDetails = campaignContentDetailsComponent;

  return (
    <Section>
      <ControlLabel>Campaign details</ControlLabel>
      <CampaignSectionRow>
        <CampaignDetails data-aid="section-campaign-details" attr="campaignDetails" label="Campaign Details">
          <KeyValueReadOnlyFields
            fields={{
              Name: campaign.name,
              Description: campaign.description,
            }}
          />

          <CampaignContentDetails campaign={campaign} />
        </CampaignDetails>
      </CampaignSectionRow>
    </Section>
  );
};

export default CampaignDetailsSection;
